import { render } from "./ServiceHistory.vue?vue&type=template&id=e1051688&scoped=true"
const script = {}

import "./ServiceHistory.vue?vue&type=style&index=0&id=e1051688&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1051688"]])

export default __exports__